const slugify = (name: string): string =>
  name
    .toLowerCase()
    .replace(/\+/g, ' plus ') // replace '+' sign to word 'plus'
    .replace(/[()]/g, '') // remove '()'
    .replace(/-/g, '--') // replace '-' sign with '--' to avoid easy duplication
    .replace(/á/g, 'a') // replace Spanish accented á with regular a
    .replace(/é/g, 'e') // replace Spanish accented é with regular e
    .replace(/í/g, 'i') // replace Spanish accented í with regular i
    .replace(/ó/g, 'o') // replace Spanish accented ó with regular o
    .replace(/ô/g, 'o') // replace Spanish accented ô with regular o
    .replace(/ú/g, 'u') // replace Spanish accented ú with regular u
    .replace(/ñ/g, 'n') // replace Spanish accented ñ with regular n
    .replace(/ü/g, 'u') // replace Spanish accented ü with regular u
    .replace(/\W/g, '-') // replace non word char to '-'
    .replace(/^-*/, '') // replace leading '-'
    .replace(/-*$/, '') // removing trailing '-'
    .replace(' ', '-'); // escape spaces

export default slugify;
